"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var ContinueButton_1 = require("../buttons/continueButton/ContinueButton");
var accesoriesStyles_1 = require("./accesoriesStyles");
var Accesories = function () {
    var styles = accesoriesStyles_1.default();
    return (<core_1.Grid container spacing={2} data-test={'checkout:accesories'}>
      
      <core_1.Box className={styles.continueButtonContainer}>
        <ContinueButton_1.default testId="checkout:continue_button:accesories" activateNextStep={true}/>
      </core_1.Box>
    </core_1.Grid>);
};
exports.default = Accesories;
